import React from 'react';
import { Toaster } from 'react-hot-toast';
import RegisterPaywallFormCont from './RegisterPaywallForm';
import logo from '../../assets/Logo.svg';
import illus from '../../assets/illustration374.svg';
import styles from '../login/Login.module.css';

const RegisterPaywall = () => (
  <>
    <div className={styles.login}>
      <div className={styles['login-card']}>
        <div className={styles.images}>
          <img src={logo} alt="fewcents logo" id={styles['fewcents-logo']} />
          <img
            src={illus}
            alt="typing girl"
            id={styles['illustration-typing-girl']}
          />
        </div>
        <RegisterPaywallFormCont />
      </div>
    </div>
    <Toaster
      containerStyle={{
        top: 50,
        left: 20,
        bottom: 20,
        right: 20,
      }}
    />
  </>
);

export default RegisterPaywall;
